<template>
  <div :class="classes">
    <div v-if="isButtonDisabled" :class="infoClasses" @click="toggleLeadsToNoRecommendation">
      <info-icon />
    </div>
    <a
      href="#"
      class="gallery-item-body"
      :tabindex="tabIndex"
      :aria-disabled="galleryItemDisabled"
      @click="clickOnItem"
    >
      <img
        class="gallery-image"
        :src="item.image_url"
        :alt="item.title"
      >
      <div
        class="title-overlay"
      >
        <div class="texts">
          <div class="title">{{ item.title }}</div>
          <div v-if="!!item.subtitle" class="subtitle">{{ item.subtitle }}</div>
        </div>
        <div class="arrow">
          <svg class="arrow-icon"
               viewBox="0 0 20 20"
               width="20"
          >
            <use
              xlink:href="#angle-right"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            />
          </svg>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
// @flow

import { mapActions } from 'vuex'

import { ChatchampButton } from '@chatchamp/chatchamp-types'

import { ButtonTypes } from '../../../ChatchampButton/ButtonTypes'
import { buttonClickMixin, postMessageMixin } from '../../../../mixins'

import InfoIcon from '../../../Icons/InfoIcon.vue'

export default {
  components: {
    InfoIcon
  },
  mixins: [buttonClickMixin, postMessageMixin],
  props: {
    item: {
      type: Object, // ChatchampMessageItem
      default: () => {
      }
    },
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  data: function () {
    return {
      buttonClicked: false
    }
  },
  computed: {
    galleryItemDisabled (): boolean {
      const button = this.validButton()

      return (!this.message.lastMessage || button?.isDisabled) && button?.type !== 'url'
    },
    classes (): Object {
      return {
        'gallery-item': true,
        'gallery-item-disabled': this.galleryItemDisabled,
        'gallery-item-grayscale': this.isButtonDisabled
      }
    },
    infoClasses (): Object {
      return {
        'gallery-item-info': true,
        'gallery-item-info--disabled': !this.message.lastMessage
      }
    },
    isButtonDisabled (): boolean {
      const button = this.validButton()

      return button?.isDisabled
    },
    tabIndex () {
      return this.galleryItemDisabled ? '-1' : '0'
    }
  },
  methods: {
    ...mapActions(['toggleNotification']),
    validButton (): ChatchampButton {
      return this.item.buttons && this.item.buttons.find(button => (button.type === ButtonTypes.URL || button.type === ButtonTypes.POSTBACK))
    },
    async clickOnItem (event): void {
      event.preventDefault()

      if (this.galleryItemDisabled) return
      if (this.buttonClicked === true) return

      const button = this.validButton()
      if (button) {
        // a postback button can only be pressed once
        if (button.type === ButtonTypes.POSTBACK) this.buttonClicked = true
        await this.clickButton(button, this.message, this.item.productId)
        if (button.attribute) this.notifyUserAttributeSet(button.attribute)
      }
    },
    toggleLeadsToNoRecommendation (): void {
      this.toggleNotification('leadsToNoRecommendation')
    }
  }
}
</script>

<style src="./gallery-item.scss" />
